import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getParticipants,
  addParticipants,
  updateParticipant as updateParticipantApi,
  withdrawParticipant as withdrawParticipantApi,
  exportParticipants,
  downloadReceipt
} from "../../api/admin/tournaments.api";

/* ============================================================
   🔥 RESPONSE NORMALIZER (UPDATED TO PRESERVE SUMMARY)
============================================================ */
const normalizeResponse = (res) => {
  let data = [];

  if (Array.isArray(res?.data)) {
    data = res.data;
  } else if (Array.isArray(res?.data?.data)) {
    data = res.data.data;
  }

  return {
    data,
    // Preserve the summary object if it exists in the API response
    summary: res?.summary || { total_registered: 0, active_count: 0, withdrawn_count: 0, absent_count: 0 },
    meta: res?.meta || {
      total: data.length,
      total_pages: 1,
      page: 1,
      limit: 10,
    },
  };
};

/* ================= FETCH ================= */
/* ================= FETCH ================= */
export const fetchParticipants = createAsyncThunk(
  "admin/tournamentParticipants/fetch",
  async (
    { tournament_id, page = 1, limit = 10, search = "", status = "all" }, // ADD status here
    { rejectWithValue }
  ) => {
    try {
      const res = await getParticipants({
        tournament_id,
        page,
        limit,
        search,
        status, // PASS status here
      });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      const normalized = normalizeResponse(res);

      console.log("🔥 NORMALIZED DATA WITH SUMMARY:", normalized);

      return normalized;

    } catch (error) {
      return rejectWithValue(error.message || "Fetch failed");
    }
  }
);

/* ================= ADD ================= */
export const addParticipant = createAsyncThunk(
  "admin/tournamentParticipants/add",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await addParticipants(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;

    } catch (error) {
      return rejectWithValue(error.message || "Add failed");
    }
  }
);

/* ================= UPDATE ================= */
export const updateParticipant = createAsyncThunk(
  "admin/tournamentParticipants/update",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await updateParticipantApi(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        data: payload,
      };

    } catch (error) {
      return rejectWithValue(error.message || "Update failed");
    }
  }
);

/* ================= WITHDRAW / ABSENT ================= */
export const withdrawParticipantThunk = createAsyncThunk(
  "admin/tournamentParticipants/withdraw",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await withdrawParticipantApi(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      // Return the payload so the slice can update the status
      return { ...res, requestPayload: payload };
    } catch (error) {
      return rejectWithValue(error.message || "Withdrawal failed");
    }
  }
);

/* ================= EXPORT ================= */
export const exportParticipantsThunk = createAsyncThunk(
  "admin/tournamentParticipants/export",
  async ({ tournament_id }, { rejectWithValue }) => {
    try {
      if (!tournament_id) {
        return rejectWithValue("Tournament ID is required");
      }

      const res = await exportParticipants({ tournament_id });

      if (!res?.success) {
        return rejectWithValue(res?.message || "Export failed");
      }

      return res.data;

    } catch (error) {
      return rejectWithValue(error?.message || "Unexpected error occurred");
    }
  }
);

export const downloadReceiptThunk = createAsyncThunk(
  "admin/tournamentParticipants/receipt",
  async ({ participant_id }, { rejectWithValue }) => {
    try {
      const res = await downloadReceipt({ participant_id });

      if (!res?.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);